export const GET_STORED_REGISTRATIONS = 'app/Registration/GET_STORED_REGISTRATIONS';
export const GET_SUBSCRIPTIONS = 'app/Registration/GET_SUBSCRIPTIONS';
export const GET_PRODUCTS = 'app/Registration/GET_PRODUCTS';
export const CREATE_REGISTRATION = 'app/Registration/CREATE_REGISTRATION';
export const UPDATE_REGISTRATION = 'app/Registration/UPDATE_REGISTRATION';
export const INIT_REGISTRATION = 'app/Registration/INIT_REGISTRATION';
export const SET_ACTIVE_REGISTRATION = 'app/Registration/SET_ACTIVE_REGISTRATION';
export const SEARCH_AGENCIES = 'app/Registration/SEARCH_AGENCIES';
export const CREATE_PROFILE = 'app/Registration/CREATE_PROFILE';
export const SET_REGISTRATION_PROFILE = 'app/Registration/SET_REGISTRATION_PROFILE';
export const SET_REGISTRATION_TOKEN = 'app/Registration/SET_REGISTRATION_TOKEN';

export const REG_STEP = {
  finished: '7',
  type: '1',
  aborted: '-1',
  details: '2',
  newAgencyOrAOS: '3.1',
  paymentPlan: '3',
  payment: '4',
  contact: '5',
  congrat: '6',
};
